import { IAdminGlobalData } from "@interfaces/screens/admin-data.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { ILang } from "@models/*";
import SPFileService, { ISPFileService} from "@services/base/sp-file.service";
import { Enums, Dictionary } from "@utils";
import { IUserHelp } from "@interfaces/screens/help-data.interface";

export class ProaUserHelp extends BasePresenter<IUserHelp> {
  private currentLang: ILang;
  public currentLabels: Dictionary<string, string>;
  private _service: ISPFileService;

  constructor(view: IAdminGlobalData) {
    super(view);
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    this._service = new SPFileService();
  }

  public async initialize(){        
      const data = await this._service.getAllFiles(Enums.ListTypes.UserHelpLibrary);
      this.view.state.setData(data);
      this.dispatcherUnsetSetLoading();        
  }
}

export default ProaUserHelp;
